import script from "./confirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./confirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./confirmDialog.vue?vue&type=style&index=0&id=22300418&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22300418"]])

export default __exports__